import http from '@/shared/http.service';
import { Uris, DefaultConfig } from '@/shared/const';
import { Subject, from, EMPTY } from 'rxjs';
import { ref, onUnmounted, reactive, computed, onMounted } from 'vue';
import { Form, notification } from "ant-design-vue";
import { catchError, switchMap, throttleTime } from 'rxjs/operators';
import dayjs from 'dayjs';
import { useIdentityStore } from '@/stores/useIdentityStore';
import { useRouter } from 'vue-router';


const useForm = Form.useForm;
export default function useResource() {
    const store = useIdentityStore();
    const router = useRouter();
    const currentUser = computed(() => store.currentUser);
  

    const isAdd = ref(false);
    const form = reactive({
        id: "",
        title: "",
        content: "",
        stamp: null,
        coverImage: "",
        coverImageFiles: [],
        contentFiles: [],
        remark:"",
        publishUser:"系统管理员",
        fileType: '', 
        childFileType:null,
    });
    const categories = ref([{id: 1, name: '视频中心'},{id: 2, name: '其他资料'}]); // 存放分类

  

    let rules = reactive({
        title: [{ type: 'string', required: true, message: '请输入文件名称', trigger: 'change' }],
   stamp: [{ required: true, message: '请选择发布时间', trigger: 'change' }],
    publishUser: [{ required: true, message: '请输入发布人', trigger: 'change' }],
    fileType: [{ required: true, message: '请选择文件分类', trigger: 'change' }],
    
    coverImageFiles: [{ 
        required: true, 
        validator: (rule, value) => {
            if (!value || value.length === 0) {
                return Promise.reject('请上传文件封面');
            }
            return Promise.resolve();
        },
        trigger: 'change' 
    }],
    contentFiles: [{ 
        required: true, 
        validator: (rule, value) => {
            if (!value || value.length === 0) {
                return Promise.reject('请上传文件内容');
            }
            return Promise.resolve();
        },
        trigger: 'change' 
    }],
    });

    let { resetFields, validate, validateInfos } = useForm(form, rules);

    const defaultOrderBy = 'ViewCount';
    const defaultDirection = 'Desc';
    const params = reactive({
        pageIndex: 1,
        pageSize: DefaultConfig.PageSize,
        orderBy: defaultOrderBy,
        direction: defaultDirection,
        title: "",
        startTime: null,
        endTime: null,
    });

    const pagination = reactive({
        current: 1,
        pageSize: DefaultConfig.PageSize,
        total: 0
    });

    //分页
    const handleTableChange = (pager) => {
        // console.log(pager)
        const serchEntity = {
            title: params.title ? params.title : "",
            pageIndex: pager.current,
            pageSize: pager.pageSize,
            orderBy: params.orderBy ? params.orderBy : '',
            direction: params.direction ? params.direction : '',
        };
        getResourceList(serchEntity);
    };

    const rid = ref("");
    ///获取ID
    const GetId$ = new Subject();
    const GetIdSubscription = GetId$.pipe(
        // throttleTime(500),
        switchMap(() => http.get(Uris.GetId))
    ).subscribe(result => {
        rid.value = result;
        form.id = result;
    });

    const getKeyId = () => {
        GetId$.next();
    };

    const resourceList = ref([]);
    //获取列表
    const getResource$ = new Subject();
    const getResourceSubscription = getResource$.pipe(
        switchMap((request) => http.get(Uris.ResourceList, request))
    ).subscribe(result => {

        resourceList.value = result.list;
        if (!result.hasNextPage) {
            pagination.current = result.totalPageCount > 0 ? result.totalPageCount : 1;
        } else {
            pagination.current = result.pageIndex;
        }
        pagination.pageSize = result.pageSize;
        pagination.total = result.totalCount;

    });

    const getResourceList = (requestModel) => {
        if (requestModel) {
            params.title = requestModel.title;
            params.startTime = requestModel.startTime;
            params.endTime = requestModel.endTime;
            params.pageIndex = requestModel.pageIndex;
            params.pageSize = requestModel.pageSize;
        }
        getResource$.next(params);
    };

    //修改列表中图片值
    // const edit$ = new Subject();
    // const 

    //编辑
    const equEdit$ = new Subject();
    const equEdited$ = new Subject();
    const equEditSubscription = equEdit$.pipe(
        switchMap(requestModel => {
            return http.get(Uris.GetResource, { resourceId: requestModel.id });
        })).subscribe((v) => {
           
            equEdited$.next(v);
        });

    const editModal = requestModel => {
        resetFields();
        equEdit$.next(requestModel);
    };

    const save$ = new Subject();
    const saveSubscription = save$.pipe(
        switchMap(entity => {
            entity.coverImageFiles = [];
            return http.post(Uris.SaveResource, entity);
        })
    ).subscribe(result => {
        if (result) {

            // isVisible.value = false;
        }
    });

    //保存
    const saved$ = new Subject();
    const handleSave = (type) => {
        console.log(type);
        from(validate()).pipe(
            switchMap(validateResult => {
                form.coverImageFiles = [];
                form.contentFiles = [];
                console.log(form);
                // form.fileType = categories.value.find(cat => cat.id === form.fileType)?.name; // 获取分类名称
                if (!isAdd.value) {
                    return http.put(Uris.PutResource, form);
                }
                else
                    return http.post(Uris.PostResource, form);
            }), catchError((err, caught) => {
                console.log(err);
                return EMPTY;
            })
        ).subscribe(result => {
            notification.success({
                message: '数据已保存',
                description: '',
                duration: 2
            });
            //恢复字段验证规则
            saved$.next(type); 
        });
    };

    const deleteResource$ = new Subject();
    const deleteResourceSubScription = deleteResource$.pipe(
        switchMap(requestModel => {
            return http.delete(Uris.DeleteResource, { resourceId: requestModel.id });
        })).subscribe(result => {
            if (result) {
                getResourceList(params);
            }
        });

    const removeResource = (requestModel) => {
        deleteResource$.next(requestModel);
    };


      const childCategories = ref([]); // 存放所有新闻分类
    
        const fetchChildCategories = async () => {
            try {
            http.get(Uris.ResourceCategoryList, {  }).subscribe(t=>{
                childCategories.value = t;   
            });
            } catch (error) {
              console.error('Error fetching categories', error);
            }
          };

    onUnmounted(() => {
        getResourceSubscription.unsubscribe();
        equEditSubscription.unsubscribe();
        saveSubscription.unsubscribe();
        GetIdSubscription.unsubscribe();
        deleteResourceSubScription.unsubscribe();
    });

    return {
        getResourceList,
        resourceList,
        pagination,
        handleTableChange,
        resetFields,
        validate,
        validateInfos,
        editModal,
        handleSave,
        form,
        saved$,
        getKeyId,
        rid,
        isAdd,
        removeResource,
        currentUser,
        equEdited$,
        categories,
        childCategories,
        fetchChildCategories
    };

}